import { levels } from './logger.types';
export const getLogger = (category) => {
    const log = {};
    levels.forEach((level) => {
        log[level] = (msg, metadata = {}) => {
            const meta = Object.assign({ category }, metadata);
            if (level === 'error') {
                console.error(level, msg, meta);
            }
            else {
                console.log(level, msg, meta);
            }
        };
    });
    return log;
};
export const createLogger = getLogger;
export const Levels = {
    info: 'info',
    debug: 'debug',
    warn: 'warn',
    error: 'error',
    trace: 'trace',
};
